import React from "react";

/**
 * FormContainer Component
 *
 * Provides the common layout wrapper for all form steps in ServiceSelector.
 * Centers content vertically and horizontally with consistent styling.
 *
 * @param {ReactNode} children - The content to render inside the container
 */
const FormContainer = ({ children }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafa",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          padding: "48px 32px",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default FormContainer;
